if (!customElements.get("deck-size-view")) {
  customElements.define(
    "deck-size-view",
    class DeckSizeView extends HTMLElement {
      handle = "on";
      constructor() {
        super();

        this.popup = this.querySelector("#deck-view-wrapper");
        this.launcher = this.querySelector("a.launcher");
        this.remover = this.querySelector("a.remover");

        this.launcher.addEventListener("click", (e) => {
          e.preventDefault();
          console.log("LAUNCHER ATTAAAACK");
          this.show(this.popup);
        });
        this.remover.addEventListener("click", (e) => {
          e.preventDefault();
          this.hide(this.popup);
        });

        document.body.appendChild(this.popup);
        document.body.appendChild(this.launcher);

        this.observe();
      }
      show(target, handle = this.handle) {
        if (target.classList.contains(handle) == false) {
          target.classList.add(handle);
        }
      }
      hide(target, handle = this.handle) {
        if (target.classList.contains(handle) == true) {
          target.classList.remove(handle);
        }
      }
      observe() {
        let pTop = 0;
        let pRatio = 0;
        let is_continue = false;

        const option = {
          root: null,
          threshold: [0, 0.5, 1],
        };
        const callback = (entries, observer) => {
          entries.forEach((entry) => {
            const cTop = entry.boundingClientRect.top;
            const cRatio = entry.intersectionRatio;

            if (entry.isIntersecting == true) {
              is_continue = cRatio < pRatio && cTop < pTop;
              this.show(this.launcher);
            } else {
              if (is_continue == false) {
                this.hide(this.launcher);
              }
            }
            console.log(`is_continue: ${is_continue}`);

            pTop = cTop;
            pRatio = cRatio;
          });
        };

        const observer = new IntersectionObserver(callback, option);

        observer.observe(this);
      }
    }
  );
}
